// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__71xI9","input":"Checkbox_input__KAVVD","round":"Checkbox_round__Pc6IE","label":"Checkbox_label__O-SB1"};